import { render } from "./LeaveAttachmentsModal.vue?vue&type=template&id=46a7d827&scoped=true"
import script from "./LeaveAttachmentsModal.vue?vue&type=script&lang=js"
export * from "./LeaveAttachmentsModal.vue?vue&type=script&lang=js"

import "./LeaveAttachmentsModal.vue?vue&type=style&index=0&id=46a7d827&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a7d827"]])

export default __exports__